import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { CartSettingContent, CartSettingSwitchItem, CartSettingSwitchWrap, CartSettingTitle } from '../index.styled'
import SwitchInputControlled from '../../../Elements/inputs/SwitchInput/controlled'
import { updateCashDeskSettingsPrintSettingsThunk } from '../../../../redux/thunk/cashDeskSettings'
import { businessScopeConfig, CASH_DESK_MODULE } from '../../constants'

const CashDeskPrintSettings = React.memo(() => {
	const { t } = useTranslation()
	const printSettings = useSelector(store => store.cashDeskSettings.printSettings)
	const dispatch = useDispatch()

	const changePrintSetting = useCallback((e, id) => {
		dispatch(updateCashDeskSettingsPrintSettingsThunk(id, { disabled: e.target.checked }, CASH_DESK_MODULE))
	}, [dispatch])


	return (
		<CartSettingContent>
			<CartSettingTitle>{t('Settings.TextPrintSettings')}</CartSettingTitle>
			<CartSettingSwitchWrap>
				{businessScopeConfig.map((config, index) => {
					const businessScope = config.businessScope
					const setting = printSettings.find(item => item.businessScope === businessScope)
					const isActive = setting?.disabled
					const layout = isActive ? 'active' : ''
					return (
						<CartSettingSwitchItem key={index} className={layout}>
							<SwitchInputControlled name={`enabled-${businessScope}-print-window`}
																		 testId={`enabled-${businessScope}-print-window`}
																		 checked={isActive}
																		 onChange={e => changePrintSetting(e, setting?.id)}
																		 label={t(config.title)} />
						</CartSettingSwitchItem>
					)
				})}
			</CartSettingSwitchWrap>
		</CartSettingContent>
	)
})

CashDeskPrintSettings.displayName = 'CashDeskPrintSettings'
export default CashDeskPrintSettings
